import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Loader from 'halogen/RingLoader'
import { Button, Row, Col } from 'react-bootstrap';
import TimeOffTables from './TimeOffTables.js';
import AbsenceTables from './AbsenceTables.js';
import { connect } from 'react-redux';

class Admin extends Component {
  constructor(props) {
    super(props);

    const { user } = this.props;

    if (!(user.level && user.level === 'admin')) {
      window.location.href = '/dashboard';
      return true;
    }

  }

  render() {
    if (!this.props.user) {
      return (
        <Loader color="#26194b" size="120px" className="loader" />
      )
    }

    return (
      <div className="Admin">
        <Row>
          { this.props.user.name ? (
            <h1>Welcome back, {this.props.user.name}!</h1>
          ) : (
            <h1>Welcome back!</h1>
          ) }
        </Row>
        <Row className="actions">
          <Link to="/timeoff">
            <Button bsStyle="primary">
              Add Timeoff
            </Button>
          </Link>
          <Link to="/absence">
            <Button bsStyle="primary" style={{marginRight: 10}}>
              Add Unpaid Timeoff
            </Button>
          </Link>
          <Link to="/admin/user">
            <Button bsStyle="primary" style={{marginRight: 10}}>
              View Users
            </Button>
          </Link>
        </Row>
        <TimeOffTables
          admin
        />
        <Row>
          <Col xs={12} md={6}>
            <AbsenceTables
              admin
            />
          </Col>
        </Row>
      </div>
    );

  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js